import { cn } from '../../../shared/lib/cn';
import { GROUP_CLASS, GROUP_TEXT_CLASS } from '../../../shared/status/dictionary';
import type { IRunOutcome } from '../lib';

export const RunOutcomeBadge = ({
  outcome,
  loggedError,
  className,
}: {
  outcome: IRunOutcome;
  loggedError?: boolean;
  className?: string;
}) => (
  <span
    className={cn(
      'inline-flex items-center gap-2 text-meta',
      GROUP_TEXT_CLASS[outcome.group],
      className,
    )}
  >
    <span
      aria-hidden
      className={cn('size-dot shrink-0 rounded-full bg-current', GROUP_CLASS[outcome.group])}
    />
    <span className="font-mono">{outcome.label}</span>
    {loggedError && (
      <span
        className="font-mono text-muted"
        title="Delivered, but the transform wrote to console.error"
      >
        ⚠
      </span>
    )}
  </span>
);
